import styles from "./Home.module.css";
import ServiceCard from "../components/ServiceCard";
import Nosotros from "../components/Nosotros";
import ClientesCarousel from "../components/ClientesCarousel";
import ContactForm from "../components/forms/ContactForm"; // nuevo componente
import { servicios } from "../data/servicios";

export default function Home() {
  return (
    <>
      <section className={styles.hero}>
        <h1 className={styles.title}>
          Tu tranquilidad financiera en manos expertas
        </h1>
        <p className={styles.subtitle}>
          Consultoría, Administrativa, Financiera, Contable, Tributaria y
          Previsional
        </p>
        <a href="#contacto">
          <button>Contactanos</button>
        </a>
      </section>
      <section id="nosotros" className={styles.section}>
        <Nosotros />
      </section>

      <section id="servicios" className={styles.section}>
        <h2>NUESTROS SERVICIOS</h2>
        <div className={styles.gridServicios}>
          {servicios.map((servicio) => (
            <ServiceCard
              key={servicio.id}
              id={servicio.id}
              titulo={servicio.titulo}
              icon={servicio.icon}
            />
          ))}
        </div>
      </section>

      <section id="clientes" className={styles.section}>
        <h2>NUESTROS CLIENTES</h2>
        <ClientesCarousel />
      </section>

      <section id="contacto" className={styles.section}>
        <ContactForm />
      </section>
    </>
  );
}
